import { AnalysisRequest, AnalysisRequestRef, AnalysisRequestState } from '../types/shared/v2/AnalysisRequest';

// Ticket #821 - Pot commun : un examen est sélectionnable pour une nouvelle
// liste de travail s'il est pris en compte (stade 1) ou remis « à refaire »
// (stade 7).
export const SELECTABLE_ANALYSIS_STATES: AnalysisRequestState[] = [
    AnalysisRequestState.TakenIntoAccount,
    AnalysisRequestState.RedoRequested,
]

export function isSelectableAnalysisState(state: AnalysisRequestState | undefined): boolean {
    return state !== undefined && SELECTABLE_ANALYSIS_STATES.includes(state)
}

export function hasPendingRequests(analysisRequests: AnalysisRequest[]): boolean {
    return analysisRequests.some(ar => Object.values(ar.types).some(s => isSelectableAnalysisState(s)))
}

export function findAnalysisRequestByRef(analysisRequests: AnalysisRequest[], ref: AnalysisRequestRef): AnalysisRequest | undefined {
    return analysisRequests.find(ar => matchRef(ar, ref))
}

export function matchRef(analysisRequest: AnalysisRequest, ref: AnalysisRequestRef): boolean {
    return analysisRequest.executorSampleId == ref.executorSampleId &&
        analysisRequest.requestorSampleId === ref.requestorSampleId &&
        analysisRequest.requestDate === ref.requestDate &&
        analysisRequest.samplingEndDate === ref.samplingEndDate &&
        analysisRequest.samplingStartDate === ref.samplingStartDate
}

export function areRefEquals(ref1: AnalysisRequestRef, ref2: AnalysisRequestRef): boolean {
    return ref1.executorSampleId == ref2.executorSampleId &&
        ref1.requestorSampleId === ref2.requestorSampleId &&
        ref1.requestDate === ref2.requestDate &&
        ref1.samplingEndDate === ref2.samplingEndDate &&
        ref1.samplingStartDate === ref2.samplingStartDate
}
